import { EDictionaryTypes } from './dictionary';

export const ApiEndpoints = {
  LOG_IN: (): string => 'auth/login/first-step',
  LOG_IN_VERIFICATION: (): string => 'auth/login/second-step',
  LOG_OUT: (): string => 'auth/logout',
  REFRESH_AUTH_TOKEN: (): string => 'auth/refresh',
  VERIFY_AUTH_CODE: (code: string): string =>
    `auth/login/second-step?verificationCode=${code}`,
  ACCOUNT_CHANGE_PASSWORD: (): string => 'auth/password',
  CHANGE_FORGOT_PASSWORD_RECAPTCHA: (query: string): string => `auth/recaptcha?${query}`,
  FORGOT_PASSWORD: (query: string): string => `account/forgot-password/first-step?${query}`,
  CHANGE_PASSWORD: (query: string): string => `account/forgot-password/second-step?${query}`,
  CREATE_ACCOUNT: (): string => 'account',
  SET_PASSWORD: (): string => 'account/change-password',
  IS_LOGGED_IN: (): string => 'account/logged',
  GET_DICTIONARY: (query: string): string => `dictionary?${query}`,
  GET_DICTIONARY_PHONE: (query: string): string => `dictionary/phone_code?${query}`,
  GET_DICTIONARY_LIKE: (type: EDictionaryTypes): string =>
    `dictionary/${type}/read-all-active/search`,
  GET_GLOBAL_PROPERTIES: (): string => 'global-property',

  SAVE_APPLICATION: (): string => 'application',
  DELETE_APPLICATION: (id: string): string => `application/${id}`,
  GET_APPLICATION: (id: string): string => `application/${id}`,
  GET_APPLICATIONS: (): string => 'application',
  UPDATE_APPLICATION: (id: string): string => `application/${id}`,
};
